import * as yup from "yup";

import * as RHFUserValidationRules from "@/utils/validation/schemas/user.RHF";

import { RequiredPhoneSchema } from "../../FormFields/PhoneField/phoneField.schema";
import { ConditionalyRequiredVatSchema } from "../../FormFields/VatField/vatField.schema";

export const CustomerFormBlockValidationSchema = yup
    .object({
        firstName: RHFUserValidationRules.firstName,
        lastName: RHFUserValidationRules.lastName
    })
    .concat(RequiredPhoneSchema)
    .concat(ConditionalyRequiredVatSchema);

export type CustomerFormBlockFormValues = yup.InferType<
    typeof CustomerFormBlockValidationSchema
>;
